import { useCallback, useRef, useState } from 'react'

export const useOffsetHeight = () => {
  const [height, setHeight] = useState({ current: 0, previous: 0 })
  const observerRef = useRef<ResizeObserver | null>(null)
  const ref = useCallback((element: HTMLDivElement | null) => {
    observerRef.current?.disconnect()
    observerRef.current = null
    if (!element) {
      setHeight({ current: 0, previous: 0 })
      return
    }
    const measure = () =>
      setHeight((last) => {
        if (last.current === element.offsetHeight) return last
        return { current: element.offsetHeight, previous: last.current }
      })
    measure()
    observerRef.current = new ResizeObserver(measure)
    observerRef.current.observe(element)
  }, [])
  return [ref, height.current, height.previous === 0] as const
}
